<div class="row">
  <div class="col-md-12">
    <br>
    <div class="titulo">
        Mantenedor de Prestaciones o Beneficios
    </div>
  </div>

  <div class="col-md-12">
    <br>
    <div class="sub-titulo">
      <span class="linea">
        Listado de Prestaciones o Beneficios
      </span>

      <button type="button" class="btn btn-outline-primary botonListar" data-toggle="modal" data-target="#saveB2B" >
        Agregar Prestaciones o Beneficios
      </button>
    </div>
  </div>

  <div *ngIf="isLoading" class="text-center my-4">
    <div class="loader">
      <div class="loader__figure"></div>
      <p class="loader__label">Medis</p>
    </div>
  </div>

  <div class="col-md-12">
    <br>
    <table class="table table-bordered">
      <thead style="font-family: Mulish; font-style: normal; font-weight: bold; font-size: 20px; color: #171994; text-align: center; background-color: #e6f0ff;">
        <tr>
          <th>#</th>
          <th>Titulo</th>
          <th>SubTitulo</th>
          <th>Fecha de Creación</th>
          <th>Fecha de Vencimiento</th>
          <th>Tipo Servicio</th>
          <th>Imagen</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody style="background-color: white; font-family: Mulish; font-size: 16px; color: #3F3F3F; text-align: center;">
        <tr class="ng-star-inserted" *ngFor="let b2bAgreement of b2bAgreementList">
          <td>{{b2bAgreement.agre_id}}</td>
          <td>{{b2bAgreement.agre_title}}</td>
          <td>{{b2bAgreement.agre_subtitle}}</td>
          <td>{{b2bAgreement.fechaFrom}}</td>
          <td>{{b2bAgreement.fechaTo}}</td>
          <td>{{b2bAgreement.service}}</td>
          <td>
            <img class="svgItem" style="width: 70px;" [src]="URL_DOCS + b2bAgreement.agre_path | safeUrl" />
          </td>
          <td>
            <div class="row justify-content-center m-0">
              <div class="col-12 p-0">
                <span data-toggle="modal" data-target="#visualizarB2B" style="cursor: pointer;" (click)="clickB2B(b2bAgreement)">
                  <mat-icon role="img" class="mat-icon notranslate material-icons mat-icon-no-color" 
                      style="color: #316AD8;" aria-hidden="true" data-mat-icon-type="font">manage_search
                  </mat-icon>
                </span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>  
    </table>
  </div>
</div>

<!-- modal visualizar -->
<div class="modal fade" id="visualizarB2B" aria-labelledby="exampleModalLabel" aria-hidden="true"
    #visualizarB2B>
  <div class="modal-dialog modal-lg">
    <div class="modal-content" *ngIf="isEdit==false">
      <div class="modal-body">
        <div class="estiloBodyModal">
          <p class="tituloModal" style="margin: 0%;width: auto;">Detalle de Prestacion/Servicio B2B</p>
          <hr class="estiloHrModal">

          <p class="subTituloModal" style="margin: 0%;width: auto;">Información del Prestacion/Servicio B2B</p>
          <hr class="estiloHrModal">
          <br>
          <div class="divBodyModal row">
            <div class="col-12">
              <p class="letraNormalModal"><strong>Nombre Prestación:</strong> {{b2bAgreementSelected.agre_typ_title}} </p>
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>Titulo:</strong> {{b2bAgreementSelected.agre_title}}</p>
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>SubTitulo:</strong> {{b2bAgreementSelected.agre_subtitle}} </p>
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>Fecha de Creación:</strong> {{b2bAgreementSelected.fechaFrom}} </p>
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>Fecha de Vencimiento:</strong> {{b2bAgreementSelected.fechaTo}} </p>
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>Descripción:</strong> {{b2bAgreementSelected.agre_description}} </p>
            </div>
            <div class="col-6">
              <div class="col-6">
                <p class="letraNormalModal"><strong>Es Beneficio:</strong> {{b2bAgreementSelected.isBenefit}}</p>
              </div>
              <div class="col-6">
                <p class="letraNormalModal"><strong>Estado:</strong> {{b2bAgreementSelected.status}}</p>
              </div>
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>Imagen:</strong>
                <img  class="svgItem" [src]="URL_DOCS + b2bAgreementSelected.agre_path | safeUrl" />
              </p>
            </div>
          </div>
          <hr class="estiloHrModal">      
          <div class="container-fluid" style="padding: 10px 10px;align-items:center;text-align: center;">
            <button type="button" class="primary buttonStyleSecondary" (click)="editB2B()" >Editar</button>
          </div>

        </div>
      </div>
    </div>

    <div class="modal-content" *ngIf="isEdit==true" [class.modal-disabled]="isSubmitting">
      <div class="modal-body">
        <div class="estiloBodyModal">
          <p class="tituloModal" style="margin: 0%;width: auto;">Editar Acuerdo B2B</p>
          <hr class="estiloHrModal">
          <p class="subTituloModal" style="margin: 0%;width: auto;">Información del Acuerdo B2B</p>
          <hr class="estiloHrModal">

          <div class="divBodyModal row">

            <div class="col-12">
              <p class="letraNormalModal"><strong>Nombre Prestación:</strong></p>
              <select class="custom-select  select-user mb-sm-2" name="agreementList" [(ngModel)]="b2bAgreementSelected.agre_agre_typ_id">
                <option value='' selected>Seleccione una prestación</option>
                <ng-container *ngFor="let agreementList of b2bAgreementTypeList">
                  <option value={{agreementList.agre_typ_id}}>{{agreementList.agre_typ_title}}</option>
                </ng-container>
              </select>
            </div>

            <div class="col-6">
              <p class="letraNormalModal"><strong>Titulo:</strong></p>
              <input class="form-control camposModalAgregar" type="text" placeholder="Titulo" [(ngModel)]="b2bAgreementSelected.agre_title">
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>SubTitulo:</strong></p>
              <input class="form-control camposModalAgregar" type="text" placeholder="SubTitulo" [(ngModel)]="b2bAgreementSelected.agre_subtitle">
            </div>

            <div class="col-6">
              <p class="letraNormalModal"><strong>Fecha de Creación:</strong> </p>
              <input type="date" [(ngModel)]="b2bAgreementSelected.fechaFrom2" class="form-control" />
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>Fecha de Vencimiento:</strong> </p>
              <input type="date" [(ngModel)]="b2bAgreementSelected.fechaTo2" class="form-control" />
            </div>
            <div class="col-6">
              <br>
              <div class="row">
                <div class="col-6">
                  <div class="form-check">
                    <input class="form-check-input"
                          type="checkbox"
                          id="beneficioCheck"
                          [(ngModel)]="b2bAgreementSelected.agre_is_benefit">
                    <label class="form-check-label" for="beneficioCheck">
                      Es Beneficio
                    </label>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-check">
                    <input class="form-check-input"
                          type="checkbox"
                          id="statusCheck"
                          [(ngModel)]="b2bAgreementSelected.status">
                    <label class="form-check-label" for="statusCheck">
                      Activo
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <p class="letraNormalModal"><strong>Descripción:</strong> </p>
              <textarea [(ngModel)]="b2bAgreementSelected.agre_description" name="descripcion" class="form-control" rows="4"></textarea>
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>Imagen actual:</strong>
                <img  class="svgItem" [src]="URL_DOCS + b2bAgreementSelected.agre_path | safeUrl"/>
              </p>
            </div>

            <div class="col-6">
              <p class="letraNormalModal"><strong>Cambiar Imagen:</strong></p>
              <input type="file" (change)="onFileSelected($event)" accept="image/*" class="form-control">
            </div>

            <div class="col-12" *ngIf="imagePreview">
              <p class="letraNormalModal"><strong>Vista previa:</strong></p>
              <img [src]="imagePreview" style="width: 40%; border: 1px solid #ccc; padding: 5px;">
              <br><br>
              <button class="btn btn-outline-danger" (click)="clearSelectedImage()">Quitar imagen seleccionada</button>
            </div>

            <div class="col-12" *ngIf="imageError" style="color: red;">
              {{ imageError }}
            </div>

          </div>

          <hr class="estiloHrModal">
          <div style="display: flex; justify-content: center; align-items: center; gap: 15px; padding: 10px;">
            <button type="button" class="boton-accion colorLetraVolver" (click)="crudB2B('update')" [disabled]="isSubmitting">Guardar</button>
            <button type="button" class="boton-accion colorLetraVolver" (click)="cancelEditB2B('update')">Cancelar</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
<!-- modal visualizar -->

<!-- modal Guardar-->
<div class="modal fade" id="saveB2B" aria-labelledby="exampleModalLabel" aria-hidden="true" 
    #saveB2B data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-body">
        <div class="estiloBodyModal">
          <p class="tituloModal" style="margin: 0%;width: auto;">Crear Acuerdo B2B</p>
          <hr class="estiloHrModal">
          <p class="subTituloModal" style="margin: 0%;width: auto;">Información del Acuerdo B2B</p>
          <hr class="estiloHrModal">
  
          <div class="divBodyModal row">
  
            <div class="col-12">
              <p class="letraNormalModal"><strong>Nombre Prestación:</strong></p>
              <select class="custom-select  select-user mb-sm-2" name="agreementList" [(ngModel)]="nuevoB2BAgreement.agre_agre_typ_id">
                <option value='' selected>Seleccione una prestación</option>
                <ng-container *ngFor="let agreementList of b2bAgreementTypeList">
                  <option value={{agreementList.agre_typ_id}}>{{agreementList.agre_typ_title}}</option>
                </ng-container>
              </select>
            </div>
  
            <div class="col-6">
              <p class="letraNormalModal"><strong>Titulo:</strong></p>
              <input class="form-control camposModalAgregar" type="text" placeholder="Titulo" [(ngModel)]="nuevoB2BAgreement.agre_title">
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>SubTitulo:</strong></p>
              <input class="form-control camposModalAgregar" type="text" placeholder="SubTitulo" [(ngModel)]="nuevoB2BAgreement.agre_subtitle">
            </div>
  
            <div class="col-6">
              <p class="letraNormalModal"><strong>Fecha de Creación:</strong> </p>
              <input type="date" [(ngModel)]="nuevoB2BAgreement.fechaFrom2" class="form-control" />
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>Fecha de Vencimiento:</strong> </p>
              <input type="date" [(ngModel)]="nuevoB2BAgreement.fechaTo2" class="form-control" />
            </div>
            <div class="col-6">
              <br>
              <div class="row">
                <div class="col-6">
                  <div class="form-check">
                    <input class="form-check-input"
                          type="checkbox"
                          id="beneficioCheck"
                          [(ngModel)]="nuevoB2BAgreement.agre_is_benefit">
                    <label class="form-check-label" for="beneficioCheck">
                      Es Beneficio
                    </label>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-check">
                    <input class="form-check-input"
                          type="checkbox"
                          id="statusCheck"
                          [(ngModel)]="nuevoB2BAgreement.status">
                    <label class="form-check-label" for="statusCheck">
                      Activo
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <p class="letraNormalModal"><strong>Descripción:</strong> </p>
              <textarea [(ngModel)]="nuevoB2BAgreement.agre_description" name="descripcion" class="form-control" rows="4"></textarea>
            </div>
  
            <div class="col-6">
              <p class="letraNormalModal"><strong>Subir Imagen:</strong></p>
              <input type="file" (change)="onFileSelected($event)" accept="image/*" class="form-control">
            </div>
  
            <div class="col-12" *ngIf="imagePreview">
              <p class="letraNormalModal"><strong>Vista previa:</strong></p>
              <img [src]="imagePreview" style="width: 40%; border: 1px solid #ccc; padding: 5px;">
              <br><br>
              <button class="btn btn-outline-danger" (click)="clearSelectedImage()">Quitar imagen seleccionada</button>
            </div>
  
            <div class="col-12" *ngIf="imageError" style="color: red;">
              {{ imageError }}
            </div>
  
          </div>
  
          <hr class="estiloHrModal">
          <div style="display: flex; justify-content: center; align-items: center; gap: 15px; padding: 10px;">
            <button type="button" class="boton-accion colorLetraVolver" (click)="crudB2B('insert')" [disabled]="isSubmitting">Guardar</button>
            <button type="button" class="boton-accion colorLetraVolver" (click)="cancelEditB2B('insert')">Cancelar</button>
          </div>
  
        </div>
      </div>
    </div>
  </div>
</div>
<!-- modal Guardar-->